import Button from 'components/Button';
import Img from 'components/Img';
import { LayoutContainer } from 'components/Layout';
import Text from 'components/Text';
import ThemedBlockContainer from 'components/ThemedBlockContainer';
import type { Field, HeadingLevel, SimpleLink } from 'models/sitecore';
import type { ColorString } from 'types';

interface Props {
	bottomRightImageSrc: string | undefined;
	centerImageAlt: string | undefined;
	centerImageSrc: string | undefined;
	className?: string;
	color: ColorString;
	heading?: Field<string>;
	headingLevel?: HeadingLevel;
	id?: string;
	links: SimpleLink[];
	text?: Field<string>;
	topLeftImageSrc: string | undefined;
}

export default function ThemedIntroductionChips({
	bottomRightImageSrc,
	centerImageAlt,
	centerImageSrc,
	className,
	color,
	heading,
	headingLevel = 'h2',
	id,
	links,
	text,
	topLeftImageSrc,
}: Props) {
	return (
		<LayoutContainer id={id} outerClassName={className}>
			<Text
				as={headingLevel}
				field={heading}
				className={text ? 'mb-2' : 'mb-4'}
			/>
			<Text as="p" field={text} className="mb-6" />

			<ThemedBlockContainer
				color={color}
				topLeftImageSrc={topLeftImageSrc}
				bottomRightImageSrc={bottomRightImageSrc}
				bottomRightImageClassName="max-md:hidden"
				className="max-md:-mx-4"
				contentClassName="py-6 md:grid md:grid-cols-12 md:items-center md:gap-x-6 md:py-12"
			>
				{centerImageSrc && (
					<>
						<Img
							src={centerImageSrc}
							alt={centerImageAlt}
							width={360}
							height={180}
							jpgOptimized={false}
							className="mx-auto mb-6 md:hidden"
						/>
						<Img
							src={centerImageSrc}
							alt={centerImageAlt}
							width={810}
							height={405}
							jpgOptimized={false}
							className="col-span-6 max-md:hidden"
						/>
					</>
				)}
				<div className="flex flex-wrap items-center gap-4 max-md:px-4 md:col-span-5 md:col-start-7">
					{links.map((link) => (
						<Button
							key={link.href}
							href={link.href}
							variant="secondary"
							className="focus-visible:focus-outline-inverted"
						>
							{link.text}
						</Button>
					))}
				</div>
			</ThemedBlockContainer>
		</LayoutContainer>
	);
}
ThemedIntroductionChips.displayName = 'ThemedIntroductionChips';
